module.exports = __webpack_public_path__ + "static/media/shield_block.f45c94d8.png";